import _classCallCheck from "D:\\Work\\kazvabg\\dashboard-client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\Work\\kazvabg\\dashboard-client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "D:\\Work\\kazvabg\\dashboard-client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "D:\\Work\\kazvabg\\dashboard-client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "D:\\Work\\kazvabg\\dashboard-client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import { LATITUDE, LATITUDE2, LONGITUDE, LONGITUDE2, SHAPE } from '../../channel';
import { isValueDef } from '../../channeldef';
import { GEOJSON } from '../../type';
import { duplicate } from '../../util';
import { DataFlowNode } from './dataflow';
export var GeoJSONNode =
/*#__PURE__*/
function (_DataFlowNode) {
  _inherits(GeoJSONNode, _DataFlowNode);

  function GeoJSONNode(parent, fields, geojson, signal) {
    var _this;

    _classCallCheck(this, GeoJSONNode);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(GeoJSONNode).call(this, parent));
    _this.fields = fields;
    _this.geojson = geojson;
    _this.signal = signal;
    return _this;
  }

  _createClass(GeoJSONNode, [{
    key: "clone",
    value: function clone() {
      return new GeoJSONNode(null, duplicate(this.fields), this.geojson, this.signal);
    }
  }, {
    key: "assemble",
    value: function assemble() {
      return Object.assign({
        type: 'geojson'
      }, this.fields ? {
        fields: this.fields
      } : {}, this.geojson ? {
        geojson: this.geojson
      } : {}, {
        signal: this.signal
      });
    }
  }], [{
    key: "parseAll",
    value: function parseAll(parent, model) {
      if (model.component.projection && !model.component.projection.isFit) {
        return parent;
      }

      var geoJsonCounter = 0;
      [[LONGITUDE, LATITUDE], [LONGITUDE2, LATITUDE2]].forEach(function (coordinates) {
        var pair = coordinates.map(function (channel) {
          return model.channelHasField(channel) ? model.fieldDef(channel).field : isValueDef(model.encoding[channel]) ? {
            expr: model.encoding[channel].value + ''
          } : undefined;
        });

        if (pair[0] || pair[1]) {
          parent = new GeoJSONNode(parent, pair, null, model.getName("geojson_".concat(geoJsonCounter++)));
        }
      });

      if (model.channelHasField(SHAPE)) {
        var fieldDef = model.fieldDef(SHAPE);

        if (fieldDef.type === GEOJSON) {
          parent = new GeoJSONNode(parent, null, fieldDef.field, model.getName("geojson_".concat(geoJsonCounter++)));
        }
      }

      return parent;
    }
  }]);

  return GeoJSONNode;
}(DataFlowNode);